import React, { useState } from 'react';

import { Speaker } from '../Speaker';
import { speakerList } from '../../../utils/speackerList';
import styles from './index.module.css';

export function SpeakerGird() {
  /*  const [speakerList, setSpeakerList] = useState([]); */

  // eslint-disable-next-line no-unused-vars
  const [focusIndex, setFocusIndex] = useState(null);

  /* useEffect(() => {
    let i = 0;
    while (i < 11) {
      speakerList.push(speakerList[0]);
      i++;
    }
    setSpeakerList([...speakerList]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); */

  return (
    <div className={styles.wrap}>
      {/* 默认显示logo */}
      <div className={styles.container}>
        <div className={styles.description}>
          {/* {focusIndex !== null && (
            <>
              <div className={styles.name}>{speakerList[focusIndex].name}</div>
              <div className={styles.desContent}>
                {speakerList[focusIndex].description}
              </div>
            </>
          )} */}
        </div>
        {speakerList.map((item, i) => (
          <Speaker
            key={i}
            setFocusIndex={setFocusIndex}
            info={item}
            index={i}
          />
        ))}
      </div>
    </div>
  );
}
